import { useState, useEffect, useRef, Fragment } from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import Backdrop from '../../Backdrop/Backdrop';
import Loader from '../../Loader/Loader';
import Modal from '../../Modal/Modal';
import UploadedFileUseContent from '../../UploadedFileUseContent/UploadedFileUseContent';
import GetUsageBasedSubscription from '../../UsageBasedBilling/GetUsageBasedSubscription';

import { useStore } from '../../../hook-store/store';
// import { 
//   generateTextAudio, 
//   getTextToSpeechModels,
//   getTextToSpeechApi,
// } from '../../../utils/voice-generator2-utils/voice-generator2-utils'

// import { TEXTAUDIOTOOLSNODE_URL } from '../../../App';

import { marks } from '../../../utils/marks';
import '../VoiceGenerator2.css';

// const modelList = [
//   {language: 'en', repoId: 'csukuangfj/vits-piper-en_US-glados|1 speaker'},
//   {language: 'tha', repoId: 'csukuangfj/vits-mms-tha'},
//   {language: 'nan', repoId: 'csukuangfj/vits-mms-nan'},
// ];
  // Thai "csukuangfj/vits-mms-tha", ฉันรักคุณ
  // Min-nan (闽南话) "csukuangfj/vits-mms-nan",  ài piaǸ chiah ē iaN̂
  

function VoiceGeneratorTextInput(props) {

  const {
    showModalUseUploadedFile,
    setShowModalUseUploaded,
    textInput,
    setTextInput,
    ttsGenMaxText,
    ttsGenFreeMaxText,
    isLoading,
    setIsLoading,
  } = props;

  const [t] = useTranslation("translation");

  const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    usageBasedConfig,
  } = store.stripeData;
  // const { 
  //   textToSpeechApiExist,
  // } = store.mlVoiceStore;

  const [showUsageBasedDetail, setShowUsageBasedDetail] = useState(false);


  const handleInputClick = (event) => {
    hiddenFileSelect.current.click()
  };


  const loadTextFileHandler = async (event) => {
    try {
      
      const file = event.target.files[0]
      
      if (file.type !== 'text/plain') {
        return;
      }
      
      setIsLoading(true);

      const fileUrl = URL.createObjectURL(file);

      const result = await fetch(fileUrl);

      const resText = await result.text();

      if (resText) {
        setTextInput(resText);
      }
      
      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      throw err;
    }
  };


  const textInputHandler = (event) => {
    setTextInput(event.target.value);
    // const textArea = document.getElementById('tts-text');
    // textArea.value = event.target.value;
  }


    let genButtonDisabled = false;
  let genButtonText = `${t('voiceGenerator07', 'Generate audio')}`;
  // let numberOfSpeakerId = 1;

  // if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
  //   const selectedModelData = ttsGenModels.find(model => {
  //     return model.code === ttsGenLng;
  //   })

  //   if (selectedModelData) {
  //     selectedLngModels = [''].concat(selectedModelData.models);
  //   }

  // }


  let voiceGeneratorTextInputBody;

  voiceGeneratorTextInputBody = (
    <div>
        <div className='voiceGenerator2Section'>
          <div>
            <div className='voiceGenerator2TextInputLabels'>
              <label>
                {t('voiceGenerator05', 'text input')}
              </label>
              <input 
                type='file'
                accept='text/plain'
                ref={hiddenFileSelect}
                style={{display:"none"}}
                onChange={loadTextFileHandler}
              />
              <button className="btnBase"
                style={{border:"0.5px solid gray", borderRadius: "4px"}}
                disabled={isLoading} 
                onClick={handleInputClick}
              >
                {marks.fileTextOMark}{' '}
                {t('voiceGenerator14', 'import text file')}
              </button>
              <button className="btnBase"
                style={{border:"0.5px solid gray", borderRadius: "4px"}}
                disabled={isLoading} 
                onClick={() => { setShowModalUseUploaded(true) }}
              >
                {marks.downloadMark} {t('voiceGenerator15', 'use uploaded file')}
              </button>
            </div>
            {showModalUseUploadedFile && (
              <div>
                <Backdrop 
                  zIndex={'95'}
                  onCancel={() => { 
                    setShowModalUseUploaded(false);
                  }}
                />
                <Modal
                  onClose={() => {
                    setShowModalUseUploaded(false);
                  }}
                >
                  <UploadedFileUseContent
                    setShowModalUseUploaded={setShowModalUseUploaded}
                  />
                </Modal>
              </div>
            )}
          </div>
          <textarea 
            className='voiceGenerator2TextInput'
            rows="4" 
            placeholder="Please enter your text here and click the Generate button"
            onChange={textInputHandler}
            defaultValue={''}
            value={textInput}
          ></textarea>
          <div
            style={textInput.length > ttsGenMaxText ? { color: "red"}: null}
          >
            {t('voiceGenerator06', 'length')} {textInput.length} / {ttsGenMaxText}
            {' '}
            <span
              onClick={() => { 
                setShowUsageBasedDetail(!showUsageBasedDetail); 
              }}
            >
              ({t('voiceGenerator16', 'for free')} {"<"} {ttsGenFreeMaxText} {marks.questionCircleOMark})
            </span>
          </div>
          {showUsageBasedDetail && (
            <div>
              {t('voiceGenerator17', 'Because voice generation of longer text input uses many resources, payment is required based on the length of the text')}
              {' '}(~ {Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.textToSpeechUnit} USD).
            </div>
          )}
        </div>
    </div>
  );



  return (
    <Fragment>
      <div>
        {voiceGeneratorTextInputBody}
      </div>
      {!usageBasedPrice && (
        <GetUsageBasedSubscription />
      )}
    </Fragment>
  )
}

export default VoiceGeneratorTextInput;
